import React, {useCallback, useState} from "react";
import {Checkbox as MUICheckbox, FormControlLabel, FormGroup, FormHelperText} from "@mui/material";
import {FORM_VALIDATION_ELEMENT_CLASSNAME} from "data/constants";
import {Exist} from "views/components/exist/exist.component";
import {ICustomFieldValue} from "data/types/global";
import {CheckboxLabelTypography} from "views/components/forms/common/forms_common.component";

interface IProps {
	onChange: (params: ICustomFieldValue) => void;
	error?: string;
	defaultValue?: unknown;
	disabled?: boolean;
	isRequired: boolean;
	code: string;
	id: number;
	fieldDescription: string;
}

export const Checkbox: React.FC<IProps> = (props) => {
	const {id, fieldDescription, isRequired, code, onChange, error, defaultValue, disabled} = props;
	const [isChecked, setCheckedState] = useState(Boolean(Number(defaultValue)));
	const elementID = `custom-field-${id}`;

	const handleChange = useCallback(
		(event: React.SyntheticEvent<HTMLInputElement>) => {
			const value = event.currentTarget.checked;
			setCheckedState(value);
			onChange({id, value: String(Number(value)), name: code});
		},
		[id, code, onChange]
	);

	return (
		<FormGroup>
			<FormControlLabel
				disabled={disabled}
				labelPlacement={"end"}
				sx={{alignItems: "flex-start"}}
				control={
					<MUICheckbox
						disabled={disabled}
						id={elementID}
						checked={isChecked}
						onChange={handleChange}
						name={code}
						inputProps={{className: FORM_VALIDATION_ELEMENT_CLASSNAME}}
						required={isRequired}
					/>
				}
				label={
					<CheckboxLabelTypography
						sx={{marginTop: "10px"}}
						component="span"
						display="inline-block"
						dangerouslySetInnerHTML={{__html: fieldDescription}}
					/>
				}
			/>
			<Exist when={error}>
				<FormHelperText error>{error}</FormHelperText>
			</Exist>
		</FormGroup>
	);
};
